import { render, staticRenderFns } from "./MasivoObj.vue?vue&type=template&id=0fce89ea&"
import script from "./MasivoObj.vue?vue&type=script&lang=js&"
export * from "./MasivoObj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports